import moment, { Moment } from 'moment';

import { ModelBase } from "../abstract/model-base.model";
import { AllocationType } from "../accounting/allocation-type.model";
import { AnalyticalDistributionSection } from "./analytical-distribution-section.model";

export class AnalyticalDistribution extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalDistribution';

    private _allocationType!: AllocationType;
    private _amount!: number;
    private _amountOrg!: number;
    private _auto!: boolean;
    private _carrierId!: number;
    private _carrierType!: string;
    private _operationDate!: Moment;
    private _percentage!: number;
    private _reference!: string;
    private _sections!: AnalyticalDistributionSection[];

    public get allocationType(): AllocationType {
        return this._allocationType;
    }

    public set allocationType(value: any) {
        this._setValue('_allocationType', value, 'AllocationType');
    }

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get amountOrg(): number {
        return this._amountOrg;
    }

    public set amountOrg(value: any) {
        this._setValue('_amountOrg', value, 'float');
    }

    public get auto(): boolean {
        return this._auto;
    }

    public set auto(value: any) {
        this._setValue('_auto', value, 'boolean');
    }

    public get carrierId(): number {
        return this._carrierId;
    }

    public set carrierId(value: any) {
        this._setValue('_carrierId', value, 'integer');
    }

    public get carrierType(): string {
        return this._carrierType;
    }

    public set carrierType(value: any) {
        this._setValue('_carrierType', value, 'string');
    }

    public get operationDate(): Moment {
        return this._operationDate;
    }

    public set operationDate(value: any) {
        this._setValue('_operationDate', value, 'date');
    }

    public get percentage(): number {
        return this._percentage;
    }

    public set percentage(value: any) {
        this._setValue('_percentage', value, 'float', { precision: 5 });
    }

    public get reference(): string {
        return this._reference;
    }

    public set reference(value: any) {
        this._setValue('_reference', value, 'string');
    }

    public get sections(): AnalyticalDistributionSection[] {
        return this._sections;
    }

    public set sections(value: any) {
        this._setValue('_sections', value, 'AnalyticalDistributionSection');
    }
}
